// extracted by mini-css-extract-plugin
export default {"header":"Drawer_header__vaXyz","content":"Drawer_content__cpONN","overlay":"Drawer_overlay__1ujEM"};